export function check_facture_mat(document, folderData) {
  if (
    folderData?.use_facture_mat === true &&
    document.name === "Attestation à signer"
  ) {
    return {
      ...document,
      name: "Facture de matériaux",
      icon: "file",
    };
  } else {
    return document;
  }
}
